import { useEffect, useState, useSyncExternalStore } from 'react';
import { Group, Stack, Text } from '@mantine/core';
import { WidgetFrame, type WidgetProps } from '@ayocore/platform/client/widgets';
import { useSalesPlanRepository } from '../../../rpc';
import { crmWidgetStyle } from '../shared/presentation';
import { QuarterColumn } from './QuarterColumn';
import { SalesPlanWidgetController } from './SalesPlanWidgetController';

/** Составной виджет: план/факт филиала и сотрудника за два квартала. */
export function SalesPlanWidget({ title, className }: WidgetProps) {
  const repository = useSalesPlanRepository();
  const [controller] = useState(() => new SalesPlanWidgetController(repository));
  const { stats } = useSyncExternalStore(controller.subscribe, controller.getSnapshot);

  useEffect(() => {
    void controller.load();
    return () => controller.cancelLoad();
  }, [controller]);

  if (!stats) return null;

  return (
    <Stack gap='sm' className={className}>
      {title != null && (
        <Text size='sm' fw={600}>
          {title}
        </Text>
      )}
      <Group gap='md' grow>
        <WidgetFrame title={stats.branchName ?? 'Филиал'} radius='lg' style={crmWidgetStyle}>
          <Group gap='xl' wrap='nowrap'>
            <QuarterColumn
              label={stats.previous.quarterLabel}
              plan={stats.previous.branchPlan}
              fact={stats.previous.branchFact}
            />
            <QuarterColumn
              label={stats.current.quarterLabel}
              plan={stats.current.branchPlan}
              fact={stats.current.branchFact}
            />
          </Group>
        </WidgetFrame>
        <WidgetFrame title='Мой план' radius='lg' style={crmWidgetStyle}>
          <Group gap='xl' wrap='nowrap'>
            <QuarterColumn
              label={stats.previous.quarterLabel}
              plan={stats.previous.userPlan}
              fact={stats.previous.userFact}
            />
            <QuarterColumn
              label={stats.current.quarterLabel}
              plan={stats.current.userPlan}
              fact={stats.current.userFact}
            />
          </Group>
        </WidgetFrame>
      </Group>
    </Stack>
  );
}
